import { Auth0Client } from '@auth0/auth0-spa-js';

const baseUri = window.location.origin ;
const auth0_RedirectUri = baseUri + "/callback";

export const auth0Client = new Auth0Client({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENTID,
  // useRefreshTokens: true,
  cacheLocation: 'memory',
  authorizationParams: {
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      redirect_uri: auth0_RedirectUri,
    scope: process.env.REACT_APP_AUTH0_SCOPE,
  },
  onRedirectCallback: (appState) => {
    if (appState && appState.returnTo) {
      window.history.replaceState(
        {},
        document.title,
        appState.returnTo
      );
    }
  }
});

export const auth0SecondaryClient = new Auth0Client({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_SECONDARY_CLIENTID,
  // useRefreshTokens: true,
  cacheLocation: 'memory',
  authorizationParams: {
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      redirect_uri: auth0_RedirectUri,
    scope: process.env.REACT_APP_AUTH0_SCOPE,
  },
  onRedirectCallback: (appState) => {
    if (appState && appState.returnTo) {
      window.history.replaceState(
        {},
        document.title,
        appState.returnTo
      );
    }
  }
});

export function handleAuthentication() {
  return new Promise((resolve, reject) => {
    auth0Client.handleRedirectCallback().then(async () => {
      const user = await auth0Client.getUser();
      sessionStorage.setItem("user", JSON.stringify(user));
      resolve(user);
    }).catch(err => {
      reject(err);
    });
  });
}

export function signIn() {
  const currentUrl = window.location.pathname + window.location.search;
  localStorage.setItem("postLoginRedirect", currentUrl); // Set immediately
  auth0Client.loginWithRedirect({
    appState: {
      target: currentUrl,
      //  returnTo: postLoginRedirect
    }
  });
}

export function signOut() {
    sessionStorage.clear();
  auth0Client.logout({
      returnTo: process.env.REACT_APP_AUTH0_LOGOUTURI,
    client_id: process.env.REACT_APP_AUTH0_CLIENTID,
  });
}

const getToken = async () => {
  const accessToken = await auth0Client.getTokenSilently();
  return accessToken;
}
export { getToken };

const getSecondaryToken = async () => {
  const accessToken = await auth0SecondaryClient.getTokenSilently();
  const isAuthenticated = await auth0SecondaryClient.isAuthenticated();

  if (isAuthenticated) {
    try {
      const idTokenClaims = await auth0SecondaryClient.getIdTokenClaims();
      return idTokenClaims.__raw;
    } catch (error) {
      await auth0Client.loginWithRedirect({
        appState: {
          target: window.location.pathname,
          returnTo: window.location.pathname
        }
      });
    }
  } else {
    // The user is not authenticated, prompt them to log in
    await auth0Client.loginWithRedirect({
      appState: {
        target: window.location.pathname,
        returnTo: window.location.pathname
      }

    });

  }
}
export { getSecondaryToken };

const fetchProtectedData = async () => {
  const isAuthenticated = await auth0Client.isAuthenticated();

  if (isAuthenticated) {

    try {
      // Get ID Token

      const idTokenClaims = await auth0Client.getIdTokenClaims();
      const user = await auth0Client.getUser();
      return user;

    } catch (error) {
      console.error('Error getting token silently:', error);
      if (error.error === 'login_required') {
        // The user's session has expired, prompt them to log in again
        await auth0Client.loginWithRedirect();
      }
    }

  } else {
    // The user is not authenticated, prompt them to log in
    await auth0Client.loginWithRedirect();

  }
};

export { fetchProtectedData };

const handleLogin = async () => {
  await auth0Client.loginWithRedirect({
      redirect_uri: auth0_RedirectUri,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    scope: process.env.REACT_APP_AUTH0_SCOPE,
    appState: {
      target: window.location.pathname,
      returnTo: window.location.pathname
    }
  });
};


const getIsAuthenticated = async () => {
  const checkSessionStorageItem = async () => {
    const user = sessionStorage.getItem("user");
    return !!user;
  };
  return await checkSessionStorageItem();
}
export { handleLogin, getIsAuthenticated };